import styled from 'styled-components'

export const StyledDisplayValueText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
`
